import { PaypalToken } from './payment-paypal-token';
import { CardSlider } from './card-slider';
import { isSecondaryBlockOpened } from './payment';
import { formatUrl } from './payment-utils';
import { i18n } from '@/commons/utils';

let braintree;
let deviceData;

export function PaypalBlock(page) {
  const block = this;

  block.init = params => {
    block.container = params.container;
    block.onExpressConfirmation = params.onExpressConfirmation;
    block.header = block.container.querySelector('.dkt-block-header');
    block.content = block.container.querySelector('.dkt-block-content');
    block.id = block.container.getAttribute('data-payment-type-id');
    if (document.getElementById('orderTrackingUrl') !== null) {
      block.orderTracking = document.getElementById('orderTrackingUrl').value;
    }
    block.orderId = params.orderId;
    block.isWallet = params.isWallet || false;
    block.createCardButtons = block.container.querySelectorAll('.dkt-create-card');
    block.saveInWallet = document.getElementById('brain-tree-save-account');
    block.retryButton = block.container.querySelector('.dkt-paypal-newcard-problem-button');
    block.multiEnabled = block.container.getAttribute('data-multi-enabled');
    block.slider = new CardSlider(block);

    block.state = {
      selected: params.selected || false,
      hasError: false
    };
    block.cards = block.container.querySelectorAll('.dkt-card-slider-item');
    block.tokens = [];

    block.cards.forEach((card, index) => {
      const token = new PaypalToken(block.slider);
      let isNewAccount = false;
      let isSelected = false;
      if (card.getAttribute('data-is-favorite') === null) {
        isNewAccount = true;
        if (block.tokens.length === 0) {
          isSelected = true;
        }
      }

      token.init({
        container: card,
        index,
        isNewAccount,
        isSelected,
        isWallet: block.isWallet
      });
      block.tokens.push(token);
    });

    block.isExpress = params.isExpress || false;
    block.isCheckout = params.isCheckout || false;
    block.canAddNewCard = params.canAddNewCard || (block.container.querySelector('.dkt-flipable') !== null);

    block.events();
    if (block.canAddNewCard === true) {
      block.prepareAuth();
    } else if (block.state.selected === true) {
      block.select();
    }
  };

  block.events = () => {
    if (block.header !== null) {
      block.header.addEventListener('click', block.select);
    }
    if (block.retryButton !== null) {
      block.retryButton.addEventListener('click', block.prepareAuth);
    }
    document.addEventListener('clickedOnPay', block.submitPayment);
    document.addEventListener('PrimaryPaymentBlockSelected', block.unselect);
  };

  block.select = event => {
    if ((block.state.selected === false && event) || !event) {
      document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
        bubbles: false,
        cancelable: false,
        detail: {
          'multiEnabled': block.multiEnabled
        }
      }));

      $(block.content).slideDown('fast', () => {
        block.container.className += ' dkt-block--selected dkt-block--open';
      });
      block.state.selected = true;
      block.slider.init({
        container: block.container.querySelector('.dkt-card-slider-container'),
        parent: block,
        displayNewCard: false
      });
      if (block.isWallet === false) {
        block.selectFavoriteToken();
      }

      if (this.isPreAuthOk && page && page.enableButton) {
        page.enableButton();
      } else if (page && page.disableButton) {
        page.disableButton();
      }
    }
  };

  block.unselect = () => {
    $(block.content).slideUp('normal', () => {
      block.container.classList.remove('dkt-block--selected');
      block.container.classList.remove('dkt-block--open');
    });
    block.state.selected = false;
  };

  block.selectFavoriteToken = () => {
    if (block.isTokenFavorite() === true) {
      block.tokens.forEach((token) => {
        if (token.isFavorite === true) {
          token.select();
          block.slider.current = block.tokens.indexOf(token);
          block.slider.changeCurrent();
        }
      });
    } else if (block.tokens.length > 0) {
      block.slider.current = 0;
      block.slider.changeCurrent();
      block.tokens[0].select();
    }
  };

  block.isTokenSelected = () => {
    const selectedToken = block.tokens.filter((token) => token.state.isSelected === true);
    return (selectedToken.length >= 1);
  };

  block.isTokenFavorite = () => {
    const favoriteToken = block.tokens.filter((token) => token.state.isFavorite === true);
    return (favoriteToken.length >= 1);
  };

  block.onNewCardFormDisplayChanged = () => {
    block.tokens[block.tokens.length - 1].select();
  };

  block.submitPayment = () => {
    if (block.state.selected === false) return; // Check if this mean of payment is selected
    if (page.checkTermsOfUse() === false) return; // Check if terms of use are checked
    if (page.checkBillingAddress && page.checkBillingAddress() === false) return; // Check if billing address is OK
    if (page.isFullSecondaryPayment && page.isFullSecondaryPayment() === true) return; // Check if payment is full secondary

    block.tokens.forEach((token) => {
      if (token.state.isSelected === true) {
        if (token.isNewAccount === true) {
          block.tokenize();
        } else {
          block.submitTokenPayment(token);
        }
      }
    });
  };

  block.isNewCard = () => {
    const newCard = block.tokens.filter((token) => (token.isNewAccount === true && token.isSelected === true));
    return (newCard.length >= 1);
  };

  block.prepareAuth = () => {
    if (this.state.selected && page.disableButton) {
      page.disableButton();
    }
    const params = {
      paymentTypeId: block.id
    };

    window.getAjaxHandler()
      .withUrl(formatUrl('prepareAuth', block.orderId))
      .withParameters(params)
      .withSuccess(success)
      .call();

    function success(useless, response) {
      if (response.result && response.result.data && response.result.data.widgetKey) {
        block.container.classList.remove('dkt-block--technical-problem');

        block
          .loadBraintree()
          .then(() => {
            braintree = window.braintree;
            const widgetKey = response.result.data.widgetKey;
            const braintreeParams = {
              authorization: widgetKey
            };
            return block.initBrainTree(braintreeParams);
          })
          .then(() => {
            block.isPreAuthOk = true;
            if (block.state.selected === true) {
              block.select();
            }
          });
      } else {
        page.displayError(i18n('error.oc.call'));
        block.isPreAuthOk = false;
        block.container.classList.add('dkt-block--technical-problem');
        if (page.disableButton) {
          page.disableButton();
        }
      }
    }

  };

  block.getRedirectionUrl = () => {
    if (document.getElementById('redirectionUrl') !== null) {
      block.redirectionUrl = `${document.getElementById('redirectionUrl').value}?orderId=${window.tc_vars.order_id}`;
    }
  };

  block.submitTokenPayment = token => {
    block.getRedirectionUrl();
    const params = {
      orderId: block.orderId,
      tokenId: token.tokenId,
      paymentTypeId: block.id,
      redirectionUrl: block.redirectionUrl,
      orderTracking: block.orderTracking,
      orderAttributes: JSON.stringify(page.getAnalyticsInfos()),
      useSecondaryMop: isSecondaryBlockOpened(),
      device: deviceData
    };
    page.displayLoader();

    cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
      .onSuccess(block.onPaymentSuccess)
      .call();
  };

  block.onPaymentSuccess = (response) => {
    if (response && response.result && response.result.data) {
      const data = response.result.data;

      if (window.cube.config.anly_useLegacy === 'Y') {
        CUBE.Analytics.queue.send('proceedToConfirmation');
      }
      if (data.paymentModifiable === 'false') {
        window.location.reload();
      }

      if (data.redirectConfirmation === 'true') {
        window.location.href = data.redirectionUrl;
      }

      if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
        block.onExpressConfirmation(data.redirectConfirmation);
      }
    } else {
      page.hideLoader();
      if (response && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message){
        page.displayError(response.responseTO.errors[0].message);
      } else {
        page.displayError('PAY_0001');
      }
    }
  };

  block.submitNewCardPayment = () => {
    block.getRedirectionUrl();
    const params = {
      orderId: block.orderId,
      nonce: block.nonce,
      paymentTypeId: block.id,
      saveInWallet: (block.saveInWallet != null && block.saveInWallet.checked),
      redirectionUrl: block.redirectionUrl,
      orderTracking: block.orderTracking,
      orderAttributes: JSON.stringify(page.getAnalyticsInfos()),
      useSecondaryMop: isSecondaryBlockOpened(),
      device: deviceData
    };
    page.displayLoader();

    cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
      .onSuccess(block.onPaymentSuccess)
      .call();
  };

  block.loadBraintree = () => {
    const paypalUrl = 'https://js.braintreegateway.com/web/3.40.0/js/';
    const loadJsPromises = [];
    loadJsPromises.push(page.loadJs(`${paypalUrl}client.min.js`, 'braintree-client-script'));
    loadJsPromises.push(page.loadJs(`${paypalUrl}paypal.min.js`, 'braintree-paypal-script'));
    loadJsPromises.push(page.loadJs(`${paypalUrl}data-collector.min.js`, 'braintree-data-script'));

    return Promise.all(loadJsPromises);
  };

  block.initBrainTree = params =>
    new Promise((resolve, reject) => {
      braintree.client.create({
        authorization: params.authorization
      }, (clientErr, clientInstance) => {

        if (clientErr) {
          page.displayError(i18n('error.oc.call'));
          return reject(new Error('Could not create braintree client'));
        }

        return braintree.paypal.create({
          client: clientInstance
        }, (paypalErr, paypalInstance) => {

          if (paypalErr) {
            page.displayError(i18n('error.oc.call'));
            return reject(new Error('Could not create paypal instance'));
          }
          block.paypalInstance = paypalInstance;

          braintree.dataCollector.create({
            client: clientInstance,
            paypal: true
          }, (err, dataCollectorInstance) => {
            if (err) {
              page.displayError(i18n('error.oc.call'));
              return reject(new Error('Could not create data collector instance'));
            }

            deviceData = dataCollectorInstance.deviceData;
            return deviceData;
          });

          return resolve();
        });
      });
    });

  block.tokenize = () => {
    if (!block.paypalInstance) {
      return;
    }

    if (!block.isPreAuthOk) {
      page.hideLoader();
      page.displayError(i18n('TECH_0001'));
      return;
    }

    const config = {
      locale: `${window.tc_vars.env_country}_${window.tc_vars.env_language}`
    };

    page.displayLoader();
    config.amount = window.tc_vars.order_amount_ati_with_sf;
    config.currency = window.tc_vars.env_currency;
    if (document.getElementById('brain-tree-save-account') && document.getElementById('brain-tree-save-account').checked) {
      config.flow = 'vault';
    } else {
      config.flow = 'checkout';
    }
    block.paypalInstance.tokenize(config, (tokenizeErr, payload) => {
      if (tokenizeErr) {
        switch (tokenizeErr.code) {
          case 'PAYPAL_POPUP_CLOSED':
            page.hideLoader();
            break;
          default:
            page.displayError(i18n('error.oc.call'));
        }
        return;
      }

      block.nonce = payload.nonce;
      block.submitNewCardPayment();
    });
  };
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-paypal.js